const baseURL = 'https://weflydigitalapi.onrender.com/';

export default baseURL;
